<template>
  <div v-bind="$attrs" class="flex min-h-[50vh]">
    <div class="container py-16 m-auto text-center">
      <slot name="default">
        <h2 class="text-2xl">{{ text }}</h2>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    text: {
      type: String,
      default: null,
    }
  }
}
</script>
